import React, {useEffect, useState} from "react";
import {BreadCrumbItem} from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";
import {ItemListadoServiciosSpa, listarServiciosSpa} from "../../../services/spaServicios";

const breadCrumbs: BreadCrumbItem[] = [
    {
        path: "/",
        label: "Inicio"
    },
    {
        path: "/servicios",
        label: "Servicios"
    },
    {
        path: "/servicios/spa",
        label: "Spa",
        isActive: true
    }
]

function ListaServiciosSpa(){
    const [items, setItems] = useState([] as ItemListadoServiciosSpa[]);

    useEffect(() => {
        async function poblarItems() {
            const resp = await listarServiciosSpa();
            if(resp){
                setItems(resp);
            }
        }

        poblarItems();
    }, []);

    return (
        <Page description="Visualiza, edita y crea servicios de spa." title="Reservas de Spa" breadCrumbs={breadCrumbs}>
            <TableSection items={items} />
        </Page>
    );
}

export default ListaServiciosSpa;